import { takeLatest } from "redux-saga/effects";

import { staffSearchAction } from "pages/Staff/StaffList/Module/actions/action_type";
import { getStaffSearchResultData } from "pages/Staff/StaffList/Module/sagas/view_sagas";

import * as staffViewAction from "pages/Staff/StaffInfo/Module/actions/action_type";
import {
  getGxFeeData,
  getStaffInfoViewData,
  getWorkInfoDetailData,
  getWorkInfoListData,
} from "pages/Staff/StaffInfo/Module/sagas/view_sagas";

import {
  classSessionViewAction,
  etcSalaryViewAction,
  gxSalaryViewAction,
  mbshpSalaryViewAction,
  ptSalaryViewAction,
  salaryInfoViewAction,
  salaryStatusViewAction,
  staffStandardSalaryViewAction,
} from "pages/Staff/SalaryInfo/Module/actions/action_type";
import {
  getClassSessionData,
  getEtcSalaryData,
  getGxSalaryData,
  getMbshpSalaryData,
  getPtSalaryData,
  getSalaryInfoViewData,
  getSalaryStatusData,
  getStaffStandardSalaryStatusData,
} from "pages/Staff/SalaryInfo/Module/sagas/view_sagas";

// import { classGlobalStat } from "pages/Staff/Class/ClassStat/Module/actions/stat_act_type";
// import { getClassStatResultData } from "pages/Staff/Class/ClassStat/Module/sagas/view_sagas";

import {
  classByStaffInfo,
  ptDetailInfo,
  searchOtManageList,
  searchPtManageList,
} from "pages/Staff/Class/ClassManage/Module/actions/action_type";
import {
  getClassByStaffInfoData,
  getPtDetailInfoData,
  getSearchOtManageList,
  getSearchPtManageList,
} from "pages/Staff/Class/ClassManage/Module/sagas/view_sagas";

export function* staffServiceSaga() {
  yield takeLatest(staffSearchAction, getStaffSearchResultData);

  yield takeLatest(staffViewAction.staffInfoViewAction, getStaffInfoViewData);
  yield takeLatest(staffViewAction.staffWorkListViewAction, getWorkInfoListData);
  yield takeLatest(staffViewAction.staffWorkInfoViewAction, getWorkInfoDetailData);
  yield takeLatest(staffViewAction.staffGxFeeInfoViewAction, getGxFeeData);

  yield takeLatest(salaryInfoViewAction, getSalaryInfoViewData);
  yield takeLatest(salaryStatusViewAction, getSalaryStatusData);
  yield takeLatest(staffStandardSalaryViewAction, getStaffStandardSalaryStatusData);
  yield takeLatest(mbshpSalaryViewAction, getMbshpSalaryData);
  yield takeLatest(gxSalaryViewAction, getGxSalaryData);
  yield takeLatest(ptSalaryViewAction, getPtSalaryData);

  yield takeLatest(etcSalaryViewAction, getEtcSalaryData);
  yield takeLatest(classSessionViewAction, getClassSessionData);

  yield takeLatest(searchOtManageList, getSearchOtManageList);
  yield takeLatest(searchPtManageList, getSearchPtManageList);
  yield takeLatest(ptDetailInfo, getPtDetailInfoData);
  yield takeLatest(classByStaffInfo, getClassByStaffInfoData);
}
